import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import "./App.css";
import Store from "./Store.js";
import Header from "./components/header/header.component";
import Footer from "./components/footer/footer.component";
import HomePage from "./views/HomePage/index.jsx";
// import SignupPage from "./views/SignupPage/index.jsx";
import LoginPage from "./views/LoginPage/index.jsx";
import ConfirmationPage from "./views/ConfirmationPage/index.jsx";
import SearchPage from "./views/SearchPage/index.jsx";
import NewProjectPage from "./views/NewProjectPage/index.jsx";
import ProjectDetailPage from "./views/ProjectDetailPage/index.jsx";
import ProjectDashboardPage from "./views/ProjectDashboardPage/index.jsx";
import SearchArchivesPage from "./views/SearchArchivesPage/index.jsx";
import ArchivedProjectDashboardPage from "./views/ArchivedProjectDashboardPage/index.jsx";

function App() {
  return (
    <Store>
      <Router>
        <Route component={Header} />
        <Switch>
          <Route path="/" exact component={HomePage} />
          <Route path="/login" component={LoginPage} />
          <Route path="/confirmation" component={ConfirmationPage} />
          <Route path="/search" component={SearchPage} />
          <Route path="/new-project" component={NewProjectPage} />
          <Route path="/search-archives" component={SearchArchivesPage} />
          <Route
            path="/archive-detail/:id"
            component={ArchivedProjectDashboardPage}
          />
          <Route path="/project-detail/:id" component={ProjectDetailPage} />
          <Route
            path="/project-dashboard/:id"
            component={ProjectDashboardPage}
          />
        </Switch>
        <Footer />
      </Router>
    </Store>
  );
}

export default App;
